export type CredentialType = 'mobile' | 'sticker' | 'card';

export const CREDENTIAL_TYPES: CredentialType[] = ['mobile', 'sticker', 'card'];

const CREDENTIAL_TYPE_DISPLAY_NAMES: Record<CredentialType, string> = {
  card: 'SureCard',
  mobile: 'Mobile',
  sticker: 'SureTag'
};

export const getCredentialTypeDisplayName = (credentialType: string): string => {
  return CREDENTIAL_TYPE_DISPLAY_NAMES[credentialType as CredentialType] ?? credentialType;
};
